module.exports = " <div class=container> <ul class=topicpath> <li><a v-link=\"{ path: '/', exact: true }\">TOP</a></li> <li><a v-on:click=searchPrefectureLink(profile.address_id)>{{prefecture}}</a></li> <li v-if=district><a v-on:click=searchDistrictLink(district)>{{district}}</a></li> </ul> </div> <script type=application/ld+json v-text=jsonld></script> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/topicpath.vue
// module id = 236
// module chunks = 3